var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDownWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 9,
    viewBox: "0 0 16 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Down",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.292905 1.70711C-0.0976147 1.31658 -0.0976147 0.68342 0.292905 0.29289C0.683435 -0.09763 1.3166 -0.09763 1.70713 0.29289L8.00002 6.5858L14.2929 0.29289C14.6834 -0.09763 15.3166 -0.09763 15.7071 0.29289C16.0976 0.68342 16.0976 1.31658 15.7071 1.70711L8.70712 8.7071C8.31662 9.0976 7.68344 9.0976 7.29291 8.7071L0.292905 1.70711Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownWhite);
export default __webpack_public_path__ + "static/media/Arrow__down-white.07605bb546fc7527998145846811b688.svg";
export { ForwardRef as ReactComponent };